module.exports = __webpack_public_path__ + "static/media/eye-close-red.009d5419.svg";